import { Box, Text,Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import { useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedMenu, setHeaderText } from "../../redux/actions/actions";
import { loadReports,loadStudentReports,loadTutorsReports } from "../../redux/api_calls/apiCalls";
import ItemsList from "./ItemsList";
import StudentList from "./StudentList";
import TutorList from "./TutorList";

// import exportFromJSON from 'export-from-json'

export default function Reports() {
    // const [isLoading, setIsLoading] = useState(false)
    const headerText = useSelector(state => state.headerState.headerText)
    const { reportsData } = useSelector(state => state.reportsState)
    const { studentsData } = useSelector(state => state.studentsData)
    const { TutorsData } = useSelector(state => state.TutorsData)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    const [coursesList, setCoursesList] = useState([])
    const [studentReportList, setStudentsList] = useState([])
    const [TutorReportList, setTutorList] = useState([])

    useEffect(() => {
        dispatch(setHeaderText('Analytics'))
        dispatch(selectedMenu(6))
        dispatch(loadReports())
        dispatch(loadStudentReports())
        dispatch(loadTutorsReports())
    }, [dispatch])

     useEffect(() => {
        if (reportsData) {
            setCoursesList(reportsData)
            
        }
    }, [reportsData])

     useEffect(() => {
        if (studentsData) {
            setStudentsList(studentsData)
        }
    }, [studentsData])

      useEffect(() => {
        if (TutorsData) {
            setTutorList(TutorsData)
        }
    }, [TutorsData])

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>


            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                w='80%'
                mb='3rem'
            >
                <Box
                    w='100%'
                    d='flex'
                    flexDir='column'
                >
                   
                            <ItemsList items={coursesList} />
                    
                </Box>


            </Box>

            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='center'
                w='80%'
                mb='2rem'
            >
                <Tabs width={['100%']}>
                    <TabList style={{ border: 'none' }} variant='unstyled' colorScheme='blue'>
                        <Tab width="50%" _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ fontFamily: "Mulish, sans-serif",textTransform:"uppercase" }}>Students</Tab>
                        <Tab width="50%" _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px' }} style={{ fontFamily: "Mulish, sans-serif",textTransform:"uppercase" }}>Tutors</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel padding="0">
                        <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                            py='1rem'
                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%'>Name</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12%' textAlign='center'>Reg Id</Text>                
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12%' textAlign='center'>Email</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12%' textAlign='center'>Year</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12%' textAlign='center'>Degree</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Specification</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='12%' textAlign='center'>Status</Text>
                        </Box>
                        <StudentList participants={studentReportList} />

                        </TabPanel>
                         <TabPanel padding="0">
                         <Box
                            w='100%'
                            d='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            mb='1rem'
                            px='1rem'
                            py='1rem'
                        >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%'>Name</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Email</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Mobile Number</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>No Of Subjects Taken</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Status</Text>
                        </Box>
                        <TutorList tutors={TutorReportList} />

                        </TabPanel>
                    </TabPanels>
                </Tabs>
                
            </Box>

        </Box>
    )
}